import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ErrorComponent} from './error.component';
import {SharedModule} from '../shared/shared.module';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
    declarations: [
        ErrorComponent
    ],
    exports: [
        ErrorComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        TranslateModule.forRoot()
    ]
})
export class ErrorModule { }
